import React, { useMemo } from "react";
import { Account } from "./components/Accounts";
import { StoreWrapper } from "./context/StoreContext";
import { ViewportProvider } from "./context/ViewportContext";

import MainRoutes from "./components/MainRoutes";
import { ThemeProvider as ThemeProviderV4 } from "@material-ui/styles";
import { ThemeProvider as ThemeProviderV5 } from "@mui/material/styles";

import { ToastProvider } from "./context/ToastContext";

import { buildThemes } from "./theme/buildTheme";

export default function App() {
  localStorage.setItem("dirty", false);
  localStorage.setItem("logoutRequest", false);
  const themes = useMemo(() => buildThemes(), []);
  return (
    <ThemeProviderV5 theme={themes.v5}>
      <ThemeProviderV4 theme={themes.v4}>
        <ToastProvider>
          <Account>
            <StoreWrapper>
              <ViewportProvider>
                {/* <SocketProvider> */}
                <MainRoutes></MainRoutes>
                {/* </SocketProvider> */}
              </ViewportProvider>
            </StoreWrapper>
          </Account>
        </ToastProvider>
      </ThemeProviderV4>
    </ThemeProviderV5>
  );
}
